import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, testid, className = "" }) => (
  <p
    data-testid={testid}
    className={`text-xs sm:text-sm uppercase tracking-[0.3em] font-bold text-[#FE7815] ${className}`}
  >
    {children}
  </p>
);
